const MOBILE_BREAKPOINT = '(max-width: 1024px)';

class ImageBlock extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('.image-block__image');
    this.customText = this.querySelector('.image-block__custom-text');

    if (!(this.image instanceof HTMLImageElement) || !(this.customText instanceof HTMLElement)) return;

    this.mediaQuery ??= window.matchMedia(MOBILE_BREAKPOINT);
    this.handleViewportChange = () => this.syncTextWidth();

    this.resizeObserver = new ResizeObserver(() => {
      this.syncTextWidth();
    });

    this.resizeObserver.observe(this.image);

    if (typeof this.mediaQuery.addEventListener === 'function') {
      this.mediaQuery.addEventListener('change', this.handleViewportChange);
    } else {
      this.mediaQuery.addListener(this.handleViewportChange);
    }

    requestAnimationFrame(() => this.syncTextWidth());
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();

    if (!this.mediaQuery || !this.handleViewportChange) return;

    if (typeof this.mediaQuery.removeEventListener === 'function') {
      this.mediaQuery.removeEventListener('change', this.handleViewportChange);
    } else {
      this.mediaQuery.removeListener(this.handleViewportChange);
    }
  }

  syncTextWidth() {
    if (!(this.customText instanceof HTMLElement) || !(this.image instanceof HTMLImageElement)) return;

    if (!this.mediaQuery?.matches) {
      this.customText.style.removeProperty('width');
      return;
    }

    const { width } = this.image.getBoundingClientRect();

    if (width <= 0) return;

    this.customText.style.width = `${Math.round(width)}px`;
  }
}

if (!customElements.get('image-block')) {
  customElements.define('image-block', ImageBlock);
}
